
import NotificationContainer from '@/components/ui/NotificationContainer.vue';
import { Component, Vue } from 'vue-property-decorator';

@Component({
  name: 'blank-layout',
  components: { NotificationContainer },
})
export default class BlankLayout extends Vue {}
